module.exports = __webpack_public_path__ + "../resources/img/EF_Layer4.e76f5328.svg";